<script>
  import DotIndicator from "../components/DotIndicator.svelte";
  import Header from "../components/Header.svelte";
  import AppCard from "../components/appshowcase/AppCard.svelte";
  import { posters } from "../components/appshowcase/AppShowcaseData.js";
  import NavigationButtons from "../components/appshowcase/NavigationButtons.svelte";

  let currentIndex = 0;
  let isTransitioning = false;
  let touchStartX = 0;
  let touchEndX = 0;
  let swipeDirection = 0; // -1 for left, 0 for none, 1 for right
  let isMobileWidth = false;

  // Handles swipe gestures for mobile devices
  function handleTouchStart(e) {
    touchStartX = e.touches[0].clientX;
    swipeDirection = 0;
  }

  function handleTouchMove(e) {
    if (isTransitioning) return;

    touchEndX = e.touches[0].clientX;
    const diff = touchEndX - touchStartX;
    const threshold = 20; // Small threshold to start showing visual feedback

    if (Math.abs(diff) > threshold) {
      swipeDirection = diff > 0 ? -1 : 1; // -1 for prev, 1 for next
    } else {
      swipeDirection = 0;
    }
  }

  function handleTouchEnd() {
    // Only process swipe if not already transitioning
    if (isTransitioning) return;

    const swipeThreshold = 50; // Minimum distance for swipe detection
    const swipeDistance = touchStartX - touchEndX;

    if (swipeDistance > swipeThreshold) {
      // Swiped left (next)
      changePoster("next");
    } else if (swipeDistance < -swipeThreshold) {
      // Swiped right (prev)
      changePoster("prev");
    }

    // Reset swipe direction
    swipeDirection = 0;
  }

  function changePoster(direction) {
    if (isTransitioning) return;
    isTransitioning = true;

    if (direction === "next") {
      currentIndex = (currentIndex + 1) % posters.length;
    } else if (direction === "prev") {
      currentIndex =
        currentIndex - 1 < 0 ? posters.length - 1 : currentIndex - 1;
    }

    setTimeout(() => {
      isTransitioning = false;
    }, 500);
  }

  function handleDotClick(index) {
    currentIndex = index;
    isTransitioning = true;
    setTimeout(() => (isTransitioning = false), 500);
  }
</script>

<section id="app-show-case" class="relative py-12 md:py-20 overflow-hidden">
  <Header title="Apps" subtitle="Showcase" />

  <!-- Project Showcase -->
  <div class="relative w-full">
    <div class="relative mx-auto max-w-6xl px-4">
      <div
        class="h-[450px] md:h-[550px] relative swipe-container"
        class:swipe-left={swipeDirection === 1}
        class:swipe-right={swipeDirection === -1}
        on:touchstart={handleTouchStart}
        on:touchmove={handleTouchMove}
        on:touchend={handleTouchEnd}
      >
        {#each posters as poster, index}
          {#if index === currentIndex || index === (currentIndex + 1) % posters.length || index === (currentIndex - 1 + posters.length) % posters.length}
            <AppCard
              {poster}
              isActive={index === currentIndex}
              direction={index === (currentIndex + 1) % posters.length
                ? "next"
                : "prev"}
            />
          {/if}
        {/each}
      </div>

      <!-- Progress Indicators -->
      <DotIndicator
        total={posters.length}
        current={currentIndex}
        onDotClick={handleDotClick}
      />

      <!-- Swipe instruction for mobile -->
      <div
        class="md:hidden text-center text-sm text-gray-500 dark:text-gray-400 mt-4"
      >
        <p class="swipe-instruction">
          <span>← Swipe to navigate →</span>
        </p>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <NavigationButtons
      onPrev={() => changePoster("prev")}
      onNext={() => changePoster("next")}
    />
  </div>
</section>

<style>
  /* Mobile touch area styling */
  @media (max-width: 768px) {
    #app-show-case {
      touch-action: pan-y; /* Allow vertical scrolling but capture horizontal swipes */
    }

    .swipe-container {
      transition: transform 0.2s ease-out;
    }

    .swipe-left {
      transform: translateX(-15px); /* Visual feedback when swiping left */
    }

    .swipe-right {
      transform: translateX(15px); /* Visual feedback when swiping right */
    }

    .swipe-instruction {
      padding: 0.5rem;
      animation: pulse 2s infinite;
    }

    @keyframes pulse {
      0%,
      100% {
        opacity: 0.7;
      }
      50% {
        opacity: 0.3;
      }
    }
  }
</style>
